<template>
    <div class="Fast" :class="{ disable : disable }">  
      <video class="Fast__video" id="video" playsinline style="
            -webkit-transform: scaleX(-1);
            transform: scaleX(-1);
            visibility: auto;
            width: auto;
            height: auto;
            position: absolute;">
        </video>
      <div class="Fast__hand ">{{ msg }}</div>
      <div class="Fast__hand right">{{ res }}</div>  

      <div class="Fast__examples">
        <img id="image" :src="require('@/commons/img/bridge.jpeg')"/>
        <img id="styleImage" :src="require('@/commons/img/style.jpeg')"/>
      </div>

      <canvas id="stylizedImage" width="320" height="240"/>

    </div>
</template>

<script>

import gsap from "gsap"
import Axios from 'axios'
import * as tf from "@tensorflow/tfjs"
import { Tensor3D, Tensor4D, } from '@tensorflow/tfjs'
import { loadGraphModel } from '@tensorflow/tfjs-converter'

// import json from "./users.json";
// import * as mobilenetModule from '@tensorflow-models/mobilenet'
// import '@tensorflow/tfjs-core'
// import '@tensorflow/tfjs-backend-cpu'
// import '@tensorflow/tfjs-backend-webgl'
// import Stats from 'stats.js'
// import * as FastClassifier from '@tensorflow-models/Fast-classifier'

export default {

  name: 'Fast',
  render: h => h(), 
  data: ()=>({

   msg: 'loading model',
   res: '***',
   cn1: 0,
   cn2: 0,
   tfb: null

  }),
  beforeDestroy() {
    if(this.rafID)
      cancelAnimationFrame(this.rafID)
  },
  mounted() {

    console.log('Fast');

    const image = document.getElementById("image")
    this.$styleImage = document.getElementById("styleImage")
    this.$canvas = document.getElementById('stylizedImage')

    this.$nextTick(()=>{
      this.init()
    })

    // this.$nextTick(()=>{
    //   Axios
    //   .get('./static/style_transfer_tfjs/model.json')
    //   .then(response => {
    //     this.init(response.data)
    //   })
    //   .catch(error => {
    //     console.log(error)
    //   })
    // })

  },

  methods: {

    setupCamera: async function() {
      
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        throw new Error(
            'Browser API navigator.mediaDevices.getUserMedia not available')
      }

      const video = document.getElementById('video')
      const stream = await navigator.mediaDevices.getUserMedia({
        'audio': false,
        'video': {
          facingMode: 'user',
          width: 160,
          height: 120
        },
      })

      video.srcObject = stream

      return new Promise((resolve) => {
        video.onloadedmetadata = () => { resolve(video) }
      })
    },

    loadVideo: async function() {
      const video = await this.setupCamera()
      video.play()
      return video
    },

    preprocess(imageTensor, size) {

      this.msg = 'preprocess tensor'

      // let imageTensor = tf.browser.fromPixels(imageData)
      const offset = tf.scalar(255.0)
      const normalized = tf.scalar(1.0).sub(imageTensor.div(offset))
      const batched = normalized.expandDims(0) 
      let result = batched
      // if (size) {
      //     const imgSize = Math.min(imageData.width, imageData.height);
      //     //console.log("Image Size:" + imgSize);
      //     const left = (imageData.width - imgSize) / 2;
      //     const top = (imageData.height - imgSize) / 2;
      //     const right = (imageData.width + imgSize) / 2;
      //     const bottom = (imageData.height + imgSize) / 2;
      //     let boxes = [[top / imageData.height, left / imageData.width, bottom / imageData.height, right / imageData.width]];
      //     result = tf.image.cropAndResize(batched, boxes, [0], [size,size])
      // }
      return result
    },

    loadedModel: async function () {
      return tf.loadGraphModel('./static/style_transfer_tfjs/model.json')
    },

    init: async function() {

      this.$model = await this.loadedModel()
      const tfb = tf.browser.fromPixels(this.$styleImage)
      this.$styleImageTensor = this.preprocess(tfb)

      tf.tidy(() => {

        this.tfb = tf.browser.fromPixels(document.getElementById('image'))
        const imageTensor = this.preprocess(this.tfb)
        let result = this.$model.execute([ this.$styleImageTensor, imageTensor])
        tf.browser.toPixels(tf.squeeze(result), this.$canvas)
        this.msg = '***'

      })

      return

      let video

      try {

        video = await this.loadVideo()
        this.msg = 'training model completed'
        this.onLoop()

      } catch (e) {

        //  console.log('catch '+ e);

        throw e
      }

    },

    onLoop: async function() {

      this.tfb = tf.browser.fromPixels(document.getElementById('video'))

      tf.tidy(() => {

        const imageTensor = this.preprocess(this.tfb)
        let result = this.$model.execute([this.$styleImageTensor, imageTensor])
        tf.browser.toPixels(tf.squeeze(result), this.$canvas)

        // if(this.tfb)
        //   this.tfb.dispose()
        this.rafID = requestAnimationFrame(this.onLoop)  
   
      })

    },
 
  }
}
</script>

<style lang="stylus">

@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Fast
  position absolute 
  top 0 
  left 0
  width 100vw
  height 100vh

  // overflow hidden

  &__hand 
    position absolute
    border 1px solid red
    padding 4px 16px
    width 300px
    background red
    text-align center
    height 27px

    &.right 
      right 0

  &__video 
    top 50px
    right 13px

  &__examples
    display flex 
    flex-direction column
    width 320px
    padding-top 50px
    padding-left 13px

    & img 
      margin-bottom 13px

  & canvas
    position absolute
    top 50px
    right 13px
    
  & video 
    opacity 0

</style>















